// Pager dots under a horizontally scrolling row of the Layout designs (e.g. the partner logo row). The view prints an
// empty `<nav data-rem-pager>` right after the track (`data-rem-pager-track`); the dots appear only while the row has
// more than one page, one button per page, the current one marked with aria-current.

// Items that fit on one page: the ones that start within the visible width of the track.
export const itemsPerPage = (offsets, visibleWidth) => Math.max(1, offsets.filter((offset) => offset - offsets[0] < visibleWidth - 1).length);

export const pageCount = (itemCount, perPage) => (itemCount > 0 ? Math.ceil(itemCount / perPage) : 0);

// The page shown at a scroll position: the end of the scroll range is always the last page.
export const currentPage = (scrollLeft, maxScroll, pages) => {
    if (pages <= 1 || maxScroll <= 0) {
        return 0;
    }

    return Math.min(pages - 1, Math.round((scrollLeft / maxScroll) * (pages - 1)));
};

const render = (pager, track) => {
    const items = Array.from(track.children);
    const perPage = itemsPerPage(items.map((item) => item.offsetLeft), track.clientWidth);
    const pages = track.scrollWidth > track.clientWidth + 1 ? pageCount(items.length, perPage) : 1;
    const label = pager.dataset.remPagerLabel || '%d';

    pager.hidden = pages <= 1;
    if (pager.childElementCount !== (pages <= 1 ? 0 : pages)) {
        pager.replaceChildren();
        for (let page = 0; pages > 1 && page < pages; page += 1) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'rem-pager__dot';
            button.setAttribute('aria-label', label.replace('%d', String(page + 1)));
            button.addEventListener('click', () => {
                const target = items[page * perPage];
                track.scrollTo({ left: target ? target.offsetLeft - items[0].offsetLeft : 0, behavior: 'smooth' });
            });
            pager.append(button);
        }
    }

    const active = currentPage(track.scrollLeft, track.scrollWidth - track.clientWidth, pages);
    Array.from(pager.children).forEach((button, page) => {
        if (page === active) {
            button.setAttribute('aria-current', 'true');
        } else {
            button.removeAttribute('aria-current');
        }
    });
};

export const initPagers = (root) => {
    root.querySelectorAll('[data-rem-pager]').forEach((pager) => {
        const track = pager.previousElementSibling;
        if (!track || !track.hasAttribute('data-rem-pager-track') || pager.dataset.remPagerBound === '1') {
            return;
        }
        pager.dataset.remPagerBound = '1';
        const update = () => render(pager, track);
        track.addEventListener('scroll', update, { passive: true });
        if (typeof ResizeObserver === 'function') {
            new ResizeObserver(update).observe(track);
        } else {
            window.addEventListener('resize', update);
        }
        update();
    });
};
